<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> RELATÓRIOS PUBLICADOS</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="getPublications()"
              >
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                :headers="headersPublication"
                :items="publications"
                sort-by="id"
              >
                <!-- eslint-disable-next-line -->
                <template v-slot:item.name="{ item }">
                  {{ item.name.replace("publications/", "") }}
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.updated_at="{ item }">
                  {{ item.updated_at | datetimeFormatBr }}
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top color="indigo darken-2">
                    <!-- eslint-disable-next-line -->
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="my-5 pa-4"
                        small
                        color="indigo darken-2"
                        target="_blank"
                        v-bind="attrs"
                        v-on="on"
                        :href="`${url}publications/download/${item.name}`"
                      >
                        <v-icon class="" color="white darken-1">
                          mdi-cloud-download
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Download</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="linkDownload"
      >
        <v-card>
          <v-card-text class="pa-10">
            <v-btn
              class="ma-5 white--text justify-center d-flex"
              large
              color="indigo"
              target="_blank"
              :href="download.link"
              @click="() => (linkDownload = false)"
            >
              <v-icon left>mdi-cloud-download</v-icon>
              CLIQUE AQUI PARA BAIXAR
            </v-btn>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="linkDownload = false">
              FECHAR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import * as HTTP from "@/api/requests/base";
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  directives: {},
  data: () => ({
    headersPublication: [
      { text: "Tipo", value: "type_text", width: 100 },
      { text: "Nome", value: "name", width: 200 },
      { text: "Data", value: "updated_at", width: 100 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    publications: [],
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    loading: false,
    messageAlert: "",
    showAlert: false,
    typeAlert: "error",
    lazy: false,
    valid: true,
    companySessionSelected: {},
    companySelected: "",
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
    url: "",
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    let yearNow = dateNow.getFullYear();
    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();

    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();

    this.url = URL;

    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
        this.companySelected = this.companySessionSelected.id;
      }
      this.initialize();
    } else {
      this.initialize();
    }

    // this.initialize();
  },
  methods: {
    initialize() {},
    async getPublications() {
      if (this.companySelected === "") {
        alert(
          "Não foi possível executar a consulta, tente novamente mais tarde"
        );
        return false;
      }
      this.loading = true;
      try {
        let res = await fetch(
          `${URL}publications?company_id=${this.companySelected}&month=${this.month}&year=${this.year}`
        );
        let response = await res.json();
        this.publications = response.publications;
        this.types = response.types;
        this.publications = this.publications.map((item) => ({
          ...item,
          type_text: this.types[item.type],
        }));
      } catch (error) {
        alert("Problema ao buscar as publicações, tente novamente mais tarde");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async exportReport() {
      // return false;
      this.loading = true;
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.month = this.month;
      data.year = this.year;
      data.exceptions = this.franchises_selected;

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}report/ranking-franchise-publication`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.download.name = response.nome;
        this.download.link = `${URL}order/download/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
